<template>
  <div
    :id="mapContainerId"
    :style="mapContainerStyle"
  >
    <template v-if="$mapProvider.Name === MapsProviderEnum.Google">
      <template v-if="mapStatic">
        <img
          :src="`https://maps.googleapis.com/maps/api/staticmap?center=${addressMarker.lat},${addressMarker.lng}&markers=${addressMarker.lat},${addressMarker.lng}&zoom=${mapZoom}&size=${width}x${height}&scale=2&language=${$i18n.locale}&key=${$mapProvider.Key}`"
          style="object-fit: cover; width: 100%; height: 100%;"
        >
      </template>

      <template v-else>
        <gmap-map
          ref="gmap"
          :center="mapCenter"
          :options="{styles: [{'featureType': 'poi', 'stylers': [{'visibility': 'off'}]}], streetViewControl: mapStyles, mapTypeControl: mapStyles}"
          :style="`width: ${width}; height: ${height};`"
          :zoom="mapZoom"
          map-type-id="roadmap"
        >
          <template v-if="showStoreMarker">
            <gmap-info-window
              :opened="infoWinOpen"
              :options="{pixelOffset: {width: 0, height: -30}}"
              :position="storeMarker"
              @closeclick="infoWinOpen = false"
            >
              <div
                class="grey--text text--darken-2"
                style="overflow: auto;"
              >
                <h2 class="text-center pb-2">
                  {{ $t('Common.App.Title') }}
                </h2>

                <div
                  v-if="storeAddressTitle"
                  class="caption pt-2"
                  style="white-space: nowrap;"
                >
                  <v-icon small>
                    mdi-map-marker
                  </v-icon>
                  {{ storeAddressTitle }}
                </div>
              </div>
            </gmap-info-window>

            <!--
            TODO
            <gmap-marker
              :icon="getContrastLogo(LOGO_TYPE.GMAP, LOGO_COLOR.DARK)"
              :position="storeMarker"
              @click="infoWinOpen=true"
            />
            -->
            <gmap-marker
              :position="storeMarker"
              @click="infoWinOpen=true"
            />

            <gmap-marker
              v-if="showAddressMarker"
              :draggable="draggable"
              :position="addressMarker"
              @dragend="onMarkerDragEnd"
            />
          </template>

          <template v-if="showDeliveryAreas && storeDeliveryAreas">
            <template v-if="storeDeliveryAreas.Circles && storeDeliveryAreas.Circles.length">
              <template v-for="(circ, index) in storeDeliveryAreas.Circles">
                <gmap-circle
                  :key="`gmap_circle_${index}`"
                  :center="circ.circle.center || storeMarker"
                  :editable="false"
                  :options="{strokeColor: circ.color, strokeOpacity: 1.0, strokeWeight: 3, fillColor: circ.color, fillOpacity: 0.15}"
                  :radius="circ.circle.radius || 1000"
                />
              </template>
            </template>

            <template v-if="storeDeliveryAreas.Polygons && storeDeliveryAreas.Polygons.length">
              <template v-for="(poly, index) in storeDeliveryAreas.Polygons">
                <gmap-polygon
                  :key="`gmap_poly_${index}`"
                  :editable="false"
                  :options="{strokeColor: poly.color, strokeOpacity: 1.0, strokeWeight: 3, fillColor: poly.color, fillOpacity: 0.15}"
                  :paths="poly.vertices"
                />
              </template>
            </template>
          </template>
        </gmap-map>
      </template>
    </template>

    <template v-if="$mapProvider.Name === MapsProviderEnum.MapBox">
      <template v-if="mapStatic">
        <img
          :src="`https://api.mapbox.com/styles/v1/mapbox/streets-v12/static/pin-l+ff0000(${addressMarker.lng},${addressMarker.lat})/${addressMarker.lng},${addressMarker.lat},${mapZoom},0.00,0.00/${width}x${height}@2x?access_token=${$mapProvider.Key}`"
          style="object-fit: cover; width: 100%; height: 100%;"
        >
      </template>

      <template v-else>
        <mgl-map
          :access-token="$mapProvider.Key"
          :center="mapCenter"
          :map-style="MapBoxStyles.Active"
          :zoom="mapZoom"
          @load="onMapBoxMapLoaded"
        >
          <v-btn-toggle
            v-if="mapStyles"
            v-model="MapBoxStyles.Active"
            class="mt-2 ml-2"
            dense
          >
            <v-btn :value="MapBoxStyles.Streets">
              {{ $t('Common.Map.Title') }}
            </v-btn>
            <v-btn :value="MapBoxStyles.Satellite">
              {{ $t('Common.Map.Satellite') }}
            </v-btn>
          </v-btn-toggle>

          <mgl-fullscreen-control position="top-right" />

          <mgl-navigation-control position="bottom-right" />

          <mgl-marker
            v-if="showStoreMarker"
            :coordinates="toMapBoxPoint(storeMarker)"
          >
            <template #marker>
              <!-- TODO -->
              <!-- <img :src="getContrastLogo(LOGO_TYPE.GMAP, LOGO_COLOR.DARK)">-->
            </template>

            <mgl-popup
              :close-on-click="false"
              :offset="30"
              :showed="infoWinOpen"
              anchor="bottom"
            >
              <div
                class="grey--text text--darken-2"
                style="overflow: auto;"
              >
                <h2 class="text-center pb-2">
                  {{ $t('Common.App.Title') }}
                </h2>

                <div
                  v-if="storeAddressTitle"
                  class="caption pt-2"
                  style="white-space: nowrap;"
                >
                  <v-icon small>
                    mdi-map-marker
                  </v-icon>
                  {{ storeAddressTitle }}
                </div>
              </div>
            </mgl-popup>
          </mgl-marker>

          <mgl-marker
            v-if="showAddressMarker"
            :coordinates="toMapBoxPoint(addressMarker)"
            :draggable="draggable"
            color="#ff0000"
            @dragend="onMarkerDragEnd"
          />
        </mgl-map>
      </template>
    </template>
  </div>
</template>

<script>
import VMapMixin from '@/theme/default/components/map/VMap.js'

export default {
  name  : 'VMap',
  mixins: [VMapMixin]
}
</script>

<style scoped src="@/theme/default/components/map/VMap.css"></style>

<style scoped>
</style>
